/* global courses */
import React from 'react';
import PropTypes from 'prop-types';
import GoogleMap from '../Map.jsx';

const SchoolPage = props => (
    <div>
        <GoogleMap schools={[{ schoolname: props.name, lat: props.lat, lng: props.lng }]} />
    </div>
);

SchoolPage.propTypes = {
    name: PropTypes.string,
    lat: PropTypes.string,
    lng: PropTypes.string,
};

export default SchoolPage;
